import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import WhatIOwnAndWhereItIsKeptStyles from "./Styles";
const PdfHeader = ({ logo, primaryColor }) => {
  const styles = WhatIOwnAndWhereItIsKeptStyles(primaryColor);
  return (
    <View style={styles.header} fixed>
      <Image src={logo} style={styles.headerLogo} />
    </View>
  );
};

export default PdfHeader;
